const constants = {
  baseUrl: 'https://uiuxstudio.netizens.dev/wp-json/wp/v2',
  // baseUrl: 'https://rdx.zzs.mybluehostin.me/projects/uiux/wp-json/wp/v2',
  frontUrl: 'https://uiuxstudio.net'
};

export default constants;
